import i18n from "@/common/i18n";
import Layout from '@/layout/embedLayout';
const router = [{
  path: '/embed/other',
  component: Layout,
  meta: {
    auth: true,
    title: i18n.t("lang.k_009001"),
    name: 'other'
  },
  hidden: true,
  children: [{
    path: 'downloadList/:id',
    component: () => import('@/views/PlatformModule/download'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_009002"),
      name: 'downloadList'
    }
  }]
}];
export default router;